/*
 * @Author: qian.tang
 * @Date: 2023-09-21 10:30:26
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2023-10-25 09:53:59
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\MasterDataPages\index.tsx
 * @Description: layout page of master section
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import React, { useState } from "react";
import AlertRules from "./AlertRules";
import AssetPreset from "./AssetPreset";
import LocationMaster from "./LocationMaster";
import PmRules from "./PmRules";
import PageTabs from "../../../../components/PageTabs";
import CategoryAndType from "./CategoryAndType";
import { getTabsArrayFromTabsObj } from "utilities/Functions/GlobalHelperFunctions";
import StoresMaster from "./StoresMaster";


const TABS = {
  ASSETPRESET: "Asset Preset",
  PMRULES: "PM Preset",
  ALERTRULES: "Alert Preset",
  CATEGORY: 'Category & Type',
  LOCATION: "Location",
  // CUSTOMERDIRECTORY: "Customer Directory",
  STORE: "Stores",
  // LOCATIONSAMPLE: "Location Map",
};

const MasterDataPages = () => {
  const tabsData = getTabsArrayFromTabsObj(TABS)

  const [tab, setTab] = useState(TABS.ASSETPRESET);



  const renderTabpages = (tab: string): JSX.Element => {
    switch (tab) {
      case TABS.ASSETPRESET:
        return <AssetPreset />
      case TABS.PMRULES:
        return <PmRules />
      case TABS.ALERTRULES:
        return <AlertRules />
      case TABS.CATEGORY:
        return <CategoryAndType />
      case TABS.LOCATION:
        return <LocationMaster />
      /// this is commented by kawal to test some map functionality, please do not delete it.....
      // case TABS.LOCATIONSAMPLE:
      //   return <LocationSample />
      // default:
      //   return <CustomerDirectoryMaster />
      default:
        return <StoresMaster />
    }
  };



  const tabs = tabsData.map((item) => {
    return {
      text: item.label,
      onClick: () => {
        setTab(item.key);
      },
    };
  });

  return (
    <>
      <PageTabs tabs={tabs} isSubTabs rowStyle={{ marginBottom: "20px", }} />
      {renderTabpages(tab)}
    </>
  );
};

export default MasterDataPages;
